
// import React from 'react';

// const SaleAllProperty = () => {
//   return (
//     <div style={{ height: '100%', width: '100%' }}>
//       <iframe
//         src="https://rentpondy.com/sale-property"
//         // src="http://localhost:3000/sale-property"
//         title="Sale Property"
//         style={{
//           width: '100%',
//           height: '100vh',
//           border: 'none',
//         }}
//       />
//     </div>
//   );
// };

// export default SaleAllProperty;








import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const SaleAllProperty = () => {
  const location = useLocation();

  // Get phone number from location state or localStorage
  const storedPhoneNumber = location.state?.phoneNumber || localStorage.getItem("phoneNumber") || "";

  // Set in state
  const [phoneNumber, setPhoneNumber] = useState(storedPhoneNumber);



  return (
    <div style={{ height: '100%', width: '100%' }}>
      {/* <iframe
src="https://rentpondy.com/sale-property"
        // src="http://localhost:3001/sale-property"
        title="Sale Property"
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
        }}
      /> */}

      <iframe
  src={`https://rentpondy.com/sale-property?phoneNumber=${encodeURIComponent(phoneNumber)}`}
  title="Sale Property"
  style={{
    width: '100%',
    height: '100vh',
    border: 'none',
  }}
/>

      
    </div>
  );
};


export default SaleAllProperty;




















// import React, { useEffect } from 'react';
// import axios from 'axios';

// const SaleAllProperty = () => {
//   useEffect(() => {
//     const handleMessage = async (event) => {
//       if (event.data?.type === 'PROPERTY_VIEW') {
//         const { rentId } = event.data;
//         const userPhoneNumber = localStorage.getItem('phoneNumber'); // or from props

//         try {
//           const res = await axios.post(`${process.env.REACT_APP_API_URL}/save-property-view`, {
//             rentId,
//             userPhoneNumber,
//           });
//           console.log(res.data.message);
//         } catch (error) {
//           console.error('Error saving property view:', error);
//         }
//       }
//     };

//     window.addEventListener('message', handleMessage);
//     return () => window.removeEventListener('message', handleMessage);
//   }, []);

//   return (
//     <div style={{ height: '100%', width: '100%' }}>
//       <iframe
//         src="http://localhost:3000/sale-property"
//         title="Sale Property"
//         style={{
//           width: '100%',
//           height: '100vh',
//           border: 'none',
//         }}
//       />
//     </div>
//   );
// };

// export default SaleAllProperty;
